import React from 'react';
const Gap = ({
  left = '0',
  right = '0',
  top = '0',
  bottom = '0',
  children = null
}) => {
  const propertyLeft = left ? `${left}rem` : '0rem';
  const propertyRight = right ? `${right}rem` : '0rem';
  const propertyTop = top ? `${top}rem` : '0rem';
  const propertyBottom = bottom ? `${bottom}rem` : '0rem';
  return /*#__PURE__*/React.createElement("div", {
    className: "ebds-gap",
    style: {
      margin: `${propertyTop} ${propertyRight} ${propertyBottom} ${propertyLeft}`
    }
  }, children);
};
export default Gap;